module.exports = __webpack_public_path__ + "img/menu.6049f2e9.svg";